import React from "react";
import {
	Box,
	Text,
	Flex,
	Button,
	VStack,
	Badge,
	HStack,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

const PricingCard = ({ handleCreateOrder }) => {
	const userPlan = useSelector((state) => state.userDetails.userplan);
	return (
		<Flex
			justify="center"
			align="flex-start"
			gap={6}
			px={6}
			py={10}
			bg="#f5f7ff"
			minH="100vh"
		>
			{/* Standard Plan */}
			<Box
				position="relative"
				bg="white"
				p={6}
				borderRadius="lg"
				w="300px"
				boxShadow="xl"
				overflow="hidden"
			>
				{/* Gradient Circle */}
				<Box
					position="absolute"
					top="-100px"
					left="-80px"
					w="300px"
					h="300px"
					bg="linear(to-br, #e3eaff, #f8faff)"
					borderRadius="full"
					zIndex={0}
				/>
				{/* Best Offer Badge */}

				<VStack spacing={3} align="flex-start" zIndex={1} position="relative">
					<HStack>
						<Text fontSize="2xl" fontWeight="bold">
							Standard
						</Text>
						<Badge
							top={4}
							left={4}
							color={"#897DF5"}
							zIndex={1}
							border={"1px solid #897DF5"}
							borderRadius={"md"}
							px={2}
							py={1}
							fontSize="8px"
						>
							Best offer
						</Badge>
					</HStack>

					<Text color="gray.500">Perfect for your growing businesses</Text>

					<Flex align="baseline">
						<Text as="s" color="gray.400" fontSize="lg">
							$200
						</Text>
						<Text fontSize="3xl" fontWeight="bold" ml={2}>
							$99
						</Text>
						<Text ml={1} fontSize="sm" color="gray.500">
							/month
						</Text>
					</Flex>

					<VStack align="start" spacing={2} pt={4}>
						{[
							"Access to Waveflow Studio",
							"Limited Workflow Creation",
							"Agent Customization",
							"Workflow Saving",
							"Agent Evaluation",
							"Standard Support",
						].map((item, idx) => (
							<Text key={idx} fontSize="sm" color="gray.700">
								✓ {item}
							</Text>
						))}
					</VStack>

					<Button
						mt={4}
						color={"#897DF5"}
						zIndex={1}
						border={"1px solid #897DF5"}
						px={2}
						py={1}
						w="100%"
						borderRadius="md"
						onClick={() => handleCreateOrder("Standard")}
					>
						Get Started
					</Button>
				</VStack>
			</Box>

			{/* standard plus card - UPDATED */}
			{userPlan == "Standard_plus" && (
				<Box
					position="relative"
					bg="white"
					p={6}
					borderRadius="lg"
					w="300px"
					boxShadow="xl"
					overflow="hidden"
				>
					{/* Gradient Circle */}
					<Box
						position="absolute"
						top="-100px"
						left="-80px"
						w="300px"
						h="300px"
						bg="linear(to-br, #e3eaff, #f8faff)"
						borderRadius="full"
						zIndex={0}
					/>

					<VStack spacing={3} align="flex-start" zIndex={1} position="relative">
						<HStack>
							<Text fontSize="2xl" fontWeight="bold">
								Standard +
							</Text>
						</HStack>

						<Text color="gray.500">Perfect for your growing businesses</Text>

						<Flex align="baseline">
							<Text as="s" color="gray.400" fontSize="lg">
								$200
							</Text>
							<Text fontSize="3xl" fontWeight="bold" ml={2}>
								$199
							</Text>
							<Text ml={1} fontSize="sm" color="gray.500">
								/month
							</Text>
						</Flex>

						<VStack align="start" spacing={2} pt={4}>
							{[
								{ text: "2,000,000 Team Credits/month", included: true },
								{ text: "1 User Seat", included: true },
								{ text: "One-click App Deployment", included: false },
								{ text: "Observability", included: false },
								{ text: "SDK/API Workflow Execution", included: true },
								{ text: "Free 100 Chat Runs", included: true },
								{ text: "Community Support", included: true },
								{ text: "SSO/RBAC not included", included: false },
							].map((feature, idx) => (
								<HStack key={idx} align="center">
									<Text fontSize="sm" fontWeight="semi-bold">
										{feature.included ? "✓" : "✕"}
									</Text>
									<Text fontSize="sm" color="gray.700" pl={2}>
										{feature.text}
									</Text>
								</HStack>
							))}
						</VStack>

						<Button
							mt={4}
							color={"#897DF5"}
							zIndex={1}
							border={"1px solid #897DF5"}
							px={2}
							py={1}
							w="100%"
							borderRadius="md"
							onClick={() => handleCreateOrder("Standard +")}
						>
							Get Started
						</Button>
					</VStack>
				</Box>
			)}

			{/* Enterprise Plan */}
			<Box
				position="relative"
				bgGradient="linear(to-br, #B5C2FB, #eaefff)"
				p={6}
				borderRadius="lg"
				w="300px"
				boxShadow="xl"
			>
				{/* Coming Soon Badge */}
				<Badge
					position="absolute"
					top={-3}
					left="50%"
					transform="translateX(-50%)"
					colorScheme="purple"
					bg="#7d67f1"
					color="white"
					borderRadius="full"
					px={3}
					py={1}
					fontSize="0.75rem"
					zIndex={1}
				>
					COMING SOON
				</Badge>

				<VStack spacing={3} align="flex-start" mt={4}>
					<Text fontSize="2xl" fontWeight="bold">
						Enterprise
					</Text>
					<Text color="gray.600">
						Take Your Business to the Next Level with Business Plan.
					</Text>

					<Text fontSize="3xl" fontWeight="bold">
						$499
						<Text as="span" fontSize="sm" color="gray.600">
							/month
						</Text>
					</Text>

					<VStack align="start" spacing={2} pt={4}>
						{[
							"Advanced Marketing Tools",
							"Customizable Templates",
							"Multi-user Access",
							"Third-party Integrations",
							"24/7 Priority Support",
						].map((item, idx) => (
							<Text key={idx} fontSize="sm" color="gray.700">
								✓ {item}
							</Text>
						))}
					</VStack>

					<Button
						mt={4}
						bg="black"
						color="white"
						w="100%"
						borderRadius="md"
						_hover={{ bg: "gray.800" }}
						isDisabled={true}
						onClick={() => handleCreateOrder("Enterprise")}
					>
						Get Started
					</Button>
				</VStack>
			</Box>
		</Flex>
	);
};

export default PricingCard;
